export const IDENTITY_CONTROLLER_END_POINTS = {
  CONTROLLER_PATH: "identity",
  TOKEN: "/connect/token",
  ACCOUNTS: "/api/accounts",
  RESET_PASSWORD: "/api/accounts/reset-password",
  COMPANY: "/api/companies",
  COMPANY_USERS: "/api/companies/users",
};
